import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ROLE_LABELS = {
  student: 'Étudiant',
  teacher: 'Enseignant',
  admin: 'Administrateur',
  tutor: 'Tuteur',
};

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="bg-white border-b border-gray-200 px-4 py-3 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <Link to="/" className="text-xl font-bold text-blue-600">StageLinks</Link>
        {user && (
          <span className="text-sm text-gray-500 hidden sm:inline">
            — {ROLE_LABELS[user.role]}
          </span>
        )}
      </div>
      {user && (
        <div className="flex items-center gap-4">
          <span className="text-sm text-gray-700 hidden sm:inline">
            {user.firstName} {user.lastName}
          </span>
          <button
            onClick={handleLogout}
            className="text-sm text-gray-600 hover:text-red-600 transition-colors"
          >
            Déconnexion
          </button>
        </div>
      )}
    </nav>
  );
}
